module.exports = __webpack_public_path__ + "assets/images/voice-feature-809d8e137fb5abb33613254dfe048a1c.png";